import { render, staticRenderFns } from "./OverlayPayment.vue?vue&type=template&id=45c66e6e&scoped=true"
import script from "./OverlayPayment.vue?vue&type=script&lang=js"
export * from "./OverlayPayment.vue?vue&type=script&lang=js"
import style0 from "./OverlayPayment.vue?vue&type=style&index=0&id=45c66e6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c66e6e",
  null
  
)

export default component.exports